import Header10 from "@/components/header/header-10";
import Hero10 from "@/components/hero/hero-10";
import {Link} from "react-router-dom";
import BlockGuide from "@/components/block/BlockGuide";
import TopDestinations from "@/components/home/home-10/TopDestinations";
import RecentlyViewed from "@/components/home/home-10/RecentlyViewed";
import TestimonialRating from "@/components/home/home-10/TestimonialRating";
import Testimonial from "@/components/home/home-10/Testimonial";

import Blog from "@/components/home/home-6/Blog.jsx";

const Home_10 = () => {
  return (
    <>
      <Header10 />
      {/* End Header 5 */}

      <Hero10 />
      {/* End Hero 5 */}

      <RecentlyViewed />
      {/* End "Ostatnio oglądane" strip - renders nothing (incl. no title) when localStorage has no entries yet */}

      <section className="layout-pt-sm layout-pb-md">
        <div className="container">
          <div className="row justify-center text-center">
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title">Dlaczego tripsi?</h2>
                <p className=" sectionTitle__text mt-5 sm:mt-0">
                  Dowiedz się dlaczego nie ma drugiej takiej wyszukiwarki jak my
                </p>
              </div>
            </div>
          </div>
          {/* End .row */}

          <div className="row y-gap-40 justify-between pt-50">
            <BlockGuide />
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>
      {/* Why choose Block Guide Section */}

      <section className="layout-pt-lg layout-pb-lg items-end"  id="inspire">
        <div className="container">
          <div className="row justify-between text-center">
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title">
                  Zainspiruj się i sprawdź najlepsze znalezione oferty
                </h2>
                <p className=" sectionTitle__text mt-5 sm:mt-0">

                </p>
              </div>
            </div>
            <div className="col-auto">
              <Link
                  to="/best-offers"
                  className="button -md -blue-1 bg-blue-1-05 text-blue-1"
              >
                Więcej <div className="icon-arrow-top-right ml-15" />
              </Link>
            </div>
          </div>

          {/* End .row  */}
          <div className="row y-gap-30 pt-40">
            <Blog />
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>



      <section className="layout-pt-lg layout-pb-lg bg-dark-3">
        <div className="container">
          <div className="row y-gap-40 justify-between text-white">
            <div className="col-xl-5 col-lg-6">
              <TestimonialRating />
            </div>
            {/* End .col */}

            <div className="col-lg-6">
              <Testimonial />
            </div>
            {/* End .col */}
          </div>
          {/* End .row */}
        </div>
      </section>
      {/* End testimonial and brand sections Section */}

      <section className="layout-pt-md layout-pb-lg m-lg-5">
        <div className="container">
          <div className="row justify-between items-end">
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title">Sprawdź nasze destynacje</h2>
                <p className=" sectionTitle__text mt-5 sm:mt-0">
                  Nie możesz się zdecydować dokąd chcesz polecieć? Sprawdź nasze propozycje!
                </p>
              </div>
            </div>
            {/* End col-auto */}

            <div className="col-auto">
              <Link
                  to={"/tour-list-v1?fromLocation=&destination=&durationMin=1&durationMax=14&onlyWeekends=false&uniqueDestinations=true&searchType="}
                  className="button -md -blue-1 bg-blue-1-05 text-blue-1"
              >
                Więcej <div className="icon-arrow-top-right ml-15" />
              </Link>
            </div>
            {/* End col-auto */}
          </div>
          {/* End .row */}

          <div className="relative mt-40 sm:mt-20 js-section-slider">
            <TopDestinations />
          </div>
          {/* End slider  */}
        </div>
        {/* End .container */}
      </section>
      {/* End .Top Destinations */}
    </>
  );
};

export default Home_10;
